/*
 * Copyright (c) 2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Injectable} from '@angular/core';
import {Tab} from './tab';
export class TabsService {
private _children: Tab[] = [];
/**
 * @param {?} tab
 * @return {?}
 */
register(tab: Tab) {
        this._children.push(tab);
    }
/**
 * @return {?}
 */
get children() {
        return this._children;
    }
/**
 * @return {?}
 */
get activeTab() {
        return this.children.find((tab: Tab) => {
            return tab.active;
        });
    }
/**
 * @return {?}
 */
get overflowTabs() {
        return this.children.filter((tab: Tab) => {
            return tab.tabLink.inOverflow === true;
        });
    }
/**
 * @param {?} tab
 * @return {?}
 */
unregister(tab: Tab) {
        const /** @type {?} */ index = this.children.indexOf(tab);
        if (index > -1) {
            this.children.splice(index, 1);
        }
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function TabsService_tsickle_Closure_declarations() {
/** @type {?} */
TabsService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TabsService.ctorParameters;
/** @type {?} */
TabsService.prototype._children;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
